module.exports = __webpack_public_path__ + "static/media/Wortox_Portrait.2617c91f.png";